import "../sass/app.scss";

import CollapseMobileMenu from "./modules/CollapseMobileMenu";
import CarouselHeroCaption from "./modules/CarouselHeroCaption";
import CarouselNews from "./modules/CarouselNews";
import CategoriesNavigation from "./modules/CategoriesNavigation";
import SearchPeople from "./modules/SearchPeople";
import SearchBar from "./modules/SearchBar";
import AboutPageLifesaver from "./modules/AboutPageLifesaver";
import SidebarNavigation from "./modules/SidebarNavigation";
import ActiveLinksStyles from "./modules/ActiveLinksStyles";
import LanguageSwitcher from "./modules/LanguageSwitcher";
import FixMobileMenuAccessibility from "./modules/FixMobileMenuAccessibility";
import MoveLoginButton from "./modules/MoveLoginButton";
import MoveWpmlSwitcherMobile from "./modules/MoveWpmlSwitcherMobile";
import ExpandActiveParent from "./modules/ExpandActiveParent";
import TwitterIconReplacer from './modules/TwitterIconReplacer';
//import CheckSubscription from "./modules/CheckSubscription";

//const collapseMobileMenu = new CollapseMobileMenu();
const carouselHeroCaption = new CarouselHeroCaption();
const carouselNews = new CarouselNews();
const categoriesNavigation = new CategoriesNavigation();
const searchPeople = new SearchPeople();
const searchBar = new SearchBar();
const aboutPageLifesaver = new AboutPageLifesaver();
const sidebarNavigation = new SidebarNavigation();
const activeLinksStyles = new ActiveLinksStyles();
//const languageSwitcher = new LanguageSwitcher();
const fixMobileMenuAccessibility = new FixMobileMenuAccessibility();
const moveLoginButton = new MoveLoginButton();
const moveWpmlSwitcherMobile = new MoveWpmlSwitcherMobile();
const expandActiveParent = new ExpandActiveParent();
//const checkSubscription = new CheckSubscription();
const twitterIconReplacer = new TwitterIconReplacer();

import CheckSubscription from './modules/CheckSubscription';

document.addEventListener('DOMContentLoaded', () => {
    console.log("Document loaded");
    new CheckSubscription();
});
